module.exports = __webpack_public_path__ + "img/logo-header-170px.b173b1a6.jpg";